import { create } from "zustand";
import { getOrganizationInfoByName } from "./api";

export const useOrganization = create((set, get) => ({
  organization: {
    isLoading: false,
    data: null,
  },
  getOrganization: async (client) => {
    set({
      organization: {
        ...get().organization,
        isLoading: true,
      },
    });

    const organizationRes = await getOrganizationInfoByName(client);

    const nextState = {
      data: organizationRes,
      isLoading: false,
    };

    if (organizationRes?.isError || !organizationRes) {
      nextState.data = null;
    }

    set({organization: nextState});
  },
}));
